import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import Grid from '../grid/Grid';
import GridElement from '../grid/GridElement';
import {timeBlocks as timeSlots} from './timeUnits';
import shortid from 'shortid';
import { connect } from 'react-redux';

//We now have some real options passed here. Do some shit with it por favor
//Somehow use index to decide which iteration of course to display since this is already inside loop

//We need to display all of the courses selected.
//If we swap selectedOptions, whatever option is selected should be displayed here.

const timeBlocks = [
    {
        name: 0,
        values: [1,2,3,4,]
    },
    {
        name: 1,
        values: [5,6,7,8]
    },
    {
        name: 2,
        values: [9,10,11,12]
    },
    {
        name: 3,
        values: [13,14,15]
    },
]

class TimeblockGrid extends Component {

    constructor(props){
        super(props);

        this.state = {
            collision: false
        }
    }

    componentDidUpdate(prevProps){
        let { cart } = this.props; 
        if(cart.items.length > prevProps.cart.items.length){
            let item = cart.items.map(item => {
                if(!prevProps.cart.items.includes(item)) return item;  
            }); 
            if(item.length === 0) return; 
            let element;
            if(item[item.length - 1]) element = document.getElementsByClassName(item[item.length - 1].code)[0];
            if(element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center'});
                }, 0);
            }
        } 
    }

    getPosition = () => {
        let { props } = this; 
        let cards = [];
                
        props.courses.map(c => {
            if(c.value.acf.options) {
                c.value.acf.options.map(option => {
                    if(props.options.includes(option.id)) {
                        cards.push({
                            id: option.id,
                            course: c
                        })
                    }
                })
                return cards;
            }
        })
        let timeBlockElements = [];
        
        cards.map((card, index) => {
            
            let day, timeStart, timeEnd, classRoom, idx;
            if(card.course.value.acf.period !== 'Helår' && card.course.value.acf.period !== this.props.selectedPeriod) return; 
            card.course.value.acf.options.map(option => {
                
                if(option.availability !== 'full' && option.id === card.id) {
                   
                    option.courses.map(courseSubject => {        
                                                
                        courseSubject.days.map((item, key) => {   
                            
                            day = parseInt(item.day);
                            timeStart = parseInt(item.time_block_start);
                            timeEnd = parseInt(item.time_block_end);
                            classRoom = item.class_room;
                            
                            //collision check
                            let collision = false; 
                            cards.forEach((cardToCheck, cardToCheckIndex) => {
                                if(cardToCheck === card) return;
                                if(cardToCheck.course.value.acf.period !== 'Helår' && cardToCheck.course.value.acf.period !== card.course.value.acf.period) return; 
                                cardToCheck.course.value.acf.options.forEach(optionToCheck => {
                                    if(!this.props.options.includes(optionToCheck.id)) return; 
                                    optionToCheck.courses.forEach(courseSubjectToCheck => {
                                        courseSubjectToCheck.days.forEach((itemToCheck, key) => {
                                            if (itemToCheck.day === item.day) {   
                                                if (timeStart <= parseInt(itemToCheck.time_block_end) && timeEnd > parseInt(itemToCheck.time_block_start)) {
                                                    collision = true;   
                                                    if(!this.state.collision){
                                                        this.props.handleCollision();
                                                    }                                          
                                                }
                                            }
                                        })
                                    })
                                })
                            });
                            
                            timeBlocks.map(block => {
                                if(block.values.includes(timeStart)) {
                                    idx = block.name;
                                }
                            })
                            
                            if(props.mobile && props.index !== idx && !props.options.includes(option.id)) return;

                            if(!props.mobile && props.index !== idx) return; 

                            if(props.mobile && props.index !== day) return; 

                            const id = shortid.generate();

                            timeBlockElements.push(
                                <StyledGridElement
                                    className={card.course.value.acf.code}
                                    key={id}
                                    colStart={day}
                                    colEnd={day + 1}
                                    rowStart={props.index === 0 ? timeStart : timeStart - (props.index * 4)}
                                    rowEnd={props.index === 0 ? timeEnd + 1 : timeEnd - (props.index * 4) + 1}
                                    collision={collision}
                                    size={timeEnd - timeStart}
                                >
                                    <div>
                                        <span className="courseTitle">{courseSubject.title || card.course.name}</span>
                                        <span className="timeSlots">{timeSlots[timeStart - 1].from} - {timeSlots[timeEnd - 1].to}</span>
                                        {classRoom && <span className="classRoom">Antall ledige plasser: {classRoom}</span>}
                                    </div>
                                </StyledGridElement>
                            )
                        })
                    });
                }
            })
        })

        if(timeBlockElements.length === 0){
            if(typeof this.props.handleEmpty === 'function'){
                this.props.handleEmpty(); 
            }
        }
        return timeBlockElements;
    }

    render(){
        const { courses } = this.props;
    
        if(!courses) return null;
    
        return (
            <StyledGrid>
                {this.getPosition()}
            </StyledGrid>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    return Object.assign({
        cart: state.cart,
    });
};

export default connect(mapStateToProps, null)(TimeblockGrid);

const StyledGrid = styled(Grid)`
    height: 100%;
    grid-template-rows: repeat(4, 60px); 

    @media(max-width: 1000px) {
        display: flex; 
        flex-direction: column; 
    }
` 

const StyledGridElement = styled(GridElement)`
    z-index: 2;
    background: #fff;
    display: flex; 
    align-items: center; 
    padding: 0 20px;
    width: calc(100% - 20px);
    
    border-bottom: 1px solid #002857;
    height: calc(100% - 1px);

    div{
        display: flex; 
        flex-direction: column; 
    }

    span {
        display: block;
        color: #000;
    }
    
    .courseTitle{
        font-size: 20px;
    }

    .timeSlots, .classRoom {
        font-size: 14px; 
    }

    ${p => p.collision && css`
        &:before{
            content: "";
            position: absolute;
            right: -7px;
            bottom: 0;
            height: calc(100% - 10px);
            border-right: 8px solid red;
        }
        &:after{
            content: "";
            position: absolute;
            right: -7px;
            bottom: -8px;
            width: calc(100% - 10px);  
            border-bottom: 8px solid red;
        }  
        z-index: calc(100 + ${p => p.size}); 
    `}

    @media(max-width: 1000px){
        padding: 10px 20px; 
        margin-bottom: 10px; 
        .courseTitle{
            font-size: 14px;
        }
        width: 100%; 
        ${p => p.collision && css`
            width: calc(100% - 8px); 
            margin-bottom: 18px;    
        `}
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/timetable/TimeblockGrid.js